
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/customer/faq",
      function () {
        return require("private-next-pages/customer/faq.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/customer/faq"])
      });
    }
  